
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  addFaq, addFaqSuccess, addFaqFailure,
  updateFaq, updateFaqSuccess, updateFaqFailure,
  deleteFaq, deleteFaqSuccess
} from './faq.actions';
import { getAllFaqs, getAllFaqsSuccess } from './faq.actions';
import { Injectable } from "@angular/core";
import { FaqService } from '../../services/FaqService';
import { map, mergeMap, catchError, of, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class FaqEffects {
  getAllFaqs$;
  addFaq$;
  updateFaq$;
  deleteFaq$;

  constructor(private actions$: Actions, private service: FaqService, private snackBar: MatSnackBar) {
    this.getAllFaqs$ = createEffect(() =>
      this.actions$.pipe(
        ofType(getAllFaqs),
        mergeMap(() =>
          this.service.getAllFaqs().pipe(
            map((faqs) => getAllFaqsSuccess({ faqs }))
          )
        )
      )
    );
    this.addFaq$ = createEffect(() =>
      this.actions$.pipe(
        ofType(addFaq),
        mergeMap(({ faq }) =>
          this.service.addFaq(faq).pipe(
            map((result) => addFaqSuccess({ faq: result })),
            tap(() => this.snackBar.open('FAQ hinzugefügt.', 'Schließen', { duration: 2500 })),
            catchError((error) => {
              this.snackBar.open('Fehler beim Hinzufügen des FAQ.', 'Schließen', { duration: 2500 });
              return of(addFaqFailure({ error }));
            })
          )
        )
      )
    );
    this.updateFaq$ = createEffect(() =>
      this.actions$.pipe(
        ofType(updateFaq),
        mergeMap(({ faq }) =>
          this.service.updateFaq(faq).pipe(
            map((result) => updateFaqSuccess({ faq: result })),
            tap(() => this.snackBar.open('FAQ aktualisiert.', 'Schließen', { duration: 2500 })),
            catchError((error) => {
              this.snackBar.open('Fehler beim Aktualisieren des FAQ.', 'Schließen', { duration: 2500 });
              return of(updateFaqFailure({ error }));
            })
          )
        )
      )
    );
    this.deleteFaq$ = createEffect(() =>
      this.actions$.pipe(
        ofType(deleteFaq),
        mergeMap(({ id }) =>
          this.service.deleteFaq(id).pipe(
            map(() => deleteFaqSuccess({ id })),
            tap(() => this.snackBar.open('FAQ gelöscht.', 'Schließen', { duration: 2500 })),
            catchError((error) => {
              this.snackBar.open('Fehler beim Löschen des FAQ.', 'Schließen', { duration: 2500 });
              return of(deleteFaqSuccess({ id: -1 }));
            })
          )
        )
      )
    );
  }
}
